import { render, staticRenderFns } from "./ListarLegajos.vue?vue&type=template&id=3bcd415e&"
import script from "./ListarLegajos.vue?vue&type=script&lang=js&"
export * from "./ListarLegajos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports